import { render, staticRenderFns } from "./BillRecord.vue?vue&type=template&id=14a239a5&scoped=true&"
import script from "./BillRecord.vue?vue&type=script&lang=js&"
export * from "./BillRecord.vue?vue&type=script&lang=js&"
import style0 from "./BillRecord.vue?vue&type=style&index=0&id=14a239a5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a239a5",
  null
  
)

export default component.exports